const Promise = require('bluebird')
const Vue = require('vue')

const scopes = {
    'weekly': 'Essa semana',
    'biweekly': 'Essa quinzena',
    'monthly': 'Esse mês',
    'bimonthly': 'Esse bimestre'
}

module.exports = () => new Promise((resolve, reject) => {
    Vue.component('individual_goals', {
        data: () => ({
            currentScopeName: 'Esse mês',
            currentScope: 'monthly',
            info: null
        }),
        ready () {
            this.info = this.data.info
        },
        methods: {
            setScope (scope) {
                this.currentScopeName = scopes[scope]
                this.currentScope = scope
            },
            getPercentage (goal) {
                const data = goal.status[this.currentScope]

                return parseFloat(data.percentage).toFixed(2)
            },
            getSubtotal (goal) {
                const data = goal.status[this.currentScope]

                return data.total
            },
            getTotal (goal) {
                return goal[this.currentScope]
            }
        },
        computed: {
            activeGoals () {
                return this.info.goals.filter(_ => _.active)
            }
        },
        watch: {
            data () {
                this.info = this.data.info
            }
        },
        template: `
          <div class="grid-item col-xs-12 col-sm-6 col-md-6 col-lg-3">
              <div class="dashboard-widget-periodos stats-dasha">
                  <div v-if="info">
                      <div>
                          <small class="font-blue-sharp" style="padding:10px 10px 0 0;font-weight:600;"><i
                                  class="fa fa-calendar"></i> PERÍODO
                          </small>
                          <div class="btn-group">
                              <button type="button" class="btn grey-silver">{{ currentScopeName }}</button>
                              <button type="button" class="btn grey-cascade dropdown-toggle" data-toggle="dropdown"
                                      aria-expanded="false"><i class="fa fa-angle-down"></i></button>
                              <ul class="dropdown-menu" role="menu">
                                  <li v-on:click="setScope('weekly')">
                                      <a href="javascript:;">Essa semana </a>
                                  </li>
                                  <li v-on:click="setScope('biweekly')">
                                      <a href="javascript:;">Essa quinzena</a>
                                  </li>
                                  <li v-on:click="setScope('monthly')">
                                      <a href="javascript:;">Esse mês</a>
                                  </li>
                                  <li v-on:click="setScope('bimonthly')">
                                      <a href="javascript:;">Esse bimestre</a>
                                  </li>
                              </ul>
                          </div>
                      </div>
                      <div v-if="activeGoals.length < 1" class="well well-sm" style="margin-top: 15px">
                        Não há metas configuradas para o usuário atual.
                      </div>
                      <div v-for="goal in activeGoals">
                          <div class="display" style="margin-top: 40px; margin-bottom: 5px">
                              <span class="font-blue-sharp" style="font-weight:600;">
                                {{ goal.typeInfo.name }}
                                <!--<a href=""><i class="fa fa-plus-square-o"></i></a>-->
                              </span>
                          </div>
                          <div class="progress-info">
                              <div class="progress">
                                <span v-bind:style="{width: getPercentage(goal) + '%'}" class="progress-bar progress-bar-success blue-madison">
                                    <span class="sr-only">{{ getPercentage(goal) }}% progress</span>
                                </span>
                              </div>
                              <div class="status">
                                  <div class="status-title">
                                      {{ getSubtotal(goal) }} de {{ getTotal(goal) }}
                                  </div>
                                  <div class="status-number">
                                      {{ getPercentage(goal) }}%
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        `,
        props: ['alias', 'data']
    })

    resolve()
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/widgets/individual_goals.js